import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('media-library-ui-root'));

/*
Note that StrictMode will call useEffect twice in development when a component mounts (not in production)
This is to help catch unsafe component lifecycles. It's kind of a pain.
You can remove the StrictMode to test without this effect.
*/
root.render(<App />);
/*
<React.StrictMode>
<App />
</React.StrictMode>
*/
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
